<template>
  <div class="page-project-baisc relative-position">
    <transition name="slide-fade" mode="out-in">
      <div v-if="!editing">
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">项目基本信息</span>
              <div class="v-ml-auto" v-if="hasPermission('project:main:house:basic:edit')">
                <a-button type="indigo" size="small" icon="form" @click="handleEdit">修改</a-button>
              </div>
            </div>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="180">项目名称</th>
                <td width="40%">{{ data.name }}</td>
                <th width="180">项目实施周期</th>
                <td>
                  {{ data.startDate ? data.startDate.substring(0, 10) : '' }}
                  <template v-if="data.endDate">~ {{ data.endDate.substring(0, 10) }}</template>
                </td>
              </tr>
              <tr>
                <th>实施地点</th>
                <td>
                  <span>{{ $utils.flatAddress(data.addresses) }}</span>
                </td>
                <th>美丽心灵管理费率</th>
                <td>
                  <span v-if="data.ownManageRate != void 0">{{ data.ownManageRate }}%</span>
                </td>
              </tr>
              <tr>
                <th valign="top">项目概要说明</th>
                <td colspan="3">
                  <div ref="foldContent" class="fold-page-content" :class="{ 'unfold': showAllContent }">
                    <div v-html="data.content"></div>
                    <div class="fold-page-text">
                      <span class="text-indigo cursor-pointer" title="点击查看全部内容" @click="showAllContent = true"><a-icon type="down" /> 查看更多</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">项目管理人员</span>
              <div class="v-ml-auto" v-if="data.state == 7 && isProcessable(1)">
                <a-space :size="6" v-if="memberEditing">
                  <a-button icon="plus" size="small" type="indigo" @click="openMemberForm()">添加管理人员</a-button>
                  <a-button icon="close" size="small" type="default" @click="memberEditing = false">取消</a-button>
                </a-space>
                <a-button icon="form" size="small" type="indigo" @click="memberEditing = true" v-else>修改</a-button>
              </div>
            </div>
          </div>
          <a-table class="list-table" size="small" rowKey="memberId" :pagination="false" :loading="loading" :data-source="data.members" :scroll="{ x: '100%' }">
            <a-table-column title="#" data-index="index" :width="55" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="人员类型" data-index="memberDuty" :width="120" align="left" />
            <a-table-column title="姓名" data-index="memberName" :width="120" align="left" />
            <a-table-column title="联系电话" data-index="phone" :ellipsis="true" :width="180" align="left" />
            <a-table-column title="职务" data-index="memberPost" :ellipsis="true" align="left" />
            <a-table-column title="工作经验" data-index="experience" :ellipsis="true" align="left" />
            <a-table-column title="操作" data-index="action" :width="60" align="center" v-if="memberEditing">
              <template slot-scope="text, record">
                <a-space class="table-actions" :size="4">
                  <span class="table-action" title="编辑" @click="openMemberForm(record)"><a-icon type="form" /></span>
                  <span class="table-action text-red" title="删除" @click="onRemoveMember(record)"><a-icon type="close" /></span>
                </a-space>
              </template>
            </a-table-column>
          </a-table>
        </div>

        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">对应资金池</span>
              <div class="v-ml-auto" v-if="data.state == 7 && isProcessable(1)">
                <a-button icon="form" size="small" type="indigo" @click="poolModal = true">设置</a-button>
              </div>
            </div>
          </div>
          <a-table class="list-table" size="small" rowKey="id" :pagination="false" :loading="loading" :data-source="pools" :scroll="{ x: '100%' }">
            <a-table-column title="#" data-index="index" :width="55" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="资金池名称" data-index="poolName" align="left" />
            <a-table-column title="资金使用方向" data-index="usage" :width="150" align="left" />
            <a-table-column title="筹款公益平台及支付方式" data-index="phone" :ellipsis="true" align="left">
              <template slot-scope="text, record">
                <div :title="item.fundName" class="ellipsis" v-for="item in record.fundNames" :key="item.id">
                  <a-icon style="width: 18px" type="alipay-circle" class="text-blue" v-if="item.fundType == '0'" /> 
                  <a-icon style="width: 18px" type="wechat" class="text-green" v-else-if="item.fundType == '1'" /> 
                  {{ item.fundName }}
                </div>
                <div :title="item.paymentName" class="ellipsis" v-for="item in record.fundLarges" :key="item.id">
                  <i class="fa fa-cubes text-orange"></i>
                  {{ item.paymentName }}
                </div>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
      <div class="section-basic-edit" v-else>
        <div class="w1000" style="margin-top: 20px">
          <div class="panel">
            <a-form-model ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <h3 class="text-center text-primary v-my-md">修改基本信息</h3>
              <div class="panel-body">
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" prop="name" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目名称
                      </span>
                      <a-input placeholder="项目名称" v-model="form.name" ref="name" style="width: calc(100% - 40px)"/>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false" prop="period">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        实施周期
                      </span>
                      <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange" ref="datePicker2" style="width: 220px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false" prop="period" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        美丽心灵管理费率
                      </span>
                      <a-input-number ref="ownManageRate" placeholder="不超过10%" class="no-handler text-right" :min="0" :max="10" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" v-model="form.ownManageRate" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" prop="addr">
                      <span slot="label">实施地点</span>
                      <template v-if="addressList.length > 0">
                        <div class="flex items-center" v-for="(item, index) in addressList" :key="index">
                          <div style="width: calc(100% - 100px)">
                            <a-input-group compact>
                              <a-cascader changeOnSelect style="width: 320px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="选择地区" v-model="item.districts" :ref="`districts-${index}`" />
                              <a-input style="width: calc(100% - 330px)" placeholder="详细地址" allowClear v-model="item.addr" :ref="`addr-${index}`" />
                            </a-input-group>
                          </div>
                          <a-space>
                            <a-button size="small" type="primary" icon="plus" @click="onAddAddress(index + 1)"></a-button>
                            <a-button size="small" type="default" icon="close" @click="onRemoveAddress(index)"></a-button>
                          </a-space>
                        </div>
                      </template>
                      <a-button size="small" type="primary" icon="plus" @click="onAddAddress(0)" v-else>添加实施地点</a-button>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">实施概要说明</span>
                      <editor v-model="form.content" :file-params="{ fileBelongId: projectId, projectId, fileType: 13, fileSign: 'P01' }" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="text-center v-mt-md">
                  <a-space :size="12">
                    <a-button type="primary" size="default" icon="check" :loading="saving" @click="confirmSubmit">保存</a-button>
                    <a-button type="default" size="default" icon="close" @click="editing = false">取消</a-button>
                  </a-space>
                </div>
              </div>
            </a-form-model>
          </div>
        </div>
      </div>
    </transition>
    <!-- 成员弹窗 -->
    <a-modal :visible="memberModal" :width="500" @cancel="memberModal = false" @ok="onSaveMember" ok-text="保存" centered :title="memberModalTitle">
      <a-form-model autocomplete="off" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            人员类型
          </span>
          <a-select placeholder="选择人员类型" v-model="memberForm.memberDuty" style="width: 100%" ref="memberDuty">
            <a-select-option v-for="item in memberDuties" :key="item.value === void 0 ? item.label : item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            姓名
          </span>
          <a-input v-model="memberForm.memberName" style="width: 100%" placeholder="联系人姓名" ref="memberName" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">职务</span>
          <a-input v-model="memberForm.memberPost" style="width: 100%" placeholder="职务" ref="memberPost" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">电话</span>
          <a-input v-model="memberForm.phone" style="width: 100%" placeholder="电话/手机号码" ref="phone" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">工作经验</span>
          <a-textarea v-model="memberForm.experience" placeholder="工作经验" ref="experience" :rows="4" />
        </a-form-item>
      </a-form-model>
    </a-modal>
    <pool-selector :project-id="projectId" v-model="poolModal" :selected="pools.map(d => d.id)" @submit="onPoolSubmit" />
  </div>
</template>

<script>
import Editor from '@/components/tinymce'
import { viewPrj, updateMain } from '@/api/project/house'
import { saveMember, delMember } from '@/api/project/common'
import { convertLxForm } from '@/utils/data'
import alldistricts from '@/utils/districts'
import all from 'gsap/all'
const memberForm = {
  id: undefined,
  memberName: '',
  memberDuty: undefined,
  phone: '',
  memberPost: '',
  experience: '',
  memberState: 1,
}
const form = {
  name: '',
  startDate: undefined,
  endDate: undefined,
  supervisor: '',
  supervisorPhone: '',
  applicantName: '',
  applicantPhone: '',
  liveWithName: '',
  liveWithPhone: '',
  houseAddr: '',
  houseProperty: undefined,
  houseArea: '',
  housePopulation: '',
  perCapitaArea: '',
  perCapitaIncome: '',
  dates: [],
}
export default {
  name: 'ProjectBasic',
  components: {
    Editor,
  },
  data() {
    return {
      loading: false,
      projectId: +this.$route.query.id,
      data: {},
      districts: alldistricts,
      pools: [],
      showAllContent: false,
      editing: false,
      form: {},
      saving: false,
      addressList: [],
      memberList: [],
      userList: [],
      poolList: [],
      memberEditing: false,
      memberModalTitle: '',
      memberModal: false,
      memberForm: { ...memberForm },
      poolModal: false,
    }
  },
  computed: {
    memberDuties: vm => vm.$store.state.app.memberDuties,
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      this.loading = true
      viewPrj(this.projectId, true).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { users = [], pools } = result
          this.pools = pools || []
          this.data = result
          this.userList = users.filter(d => d.projectUserType == 2)
        }
        this.loading = false
      })
    },
    customRow(record) {
      return {
        class: record.checked ? 'row-checked' : '',
      }
    },
    onDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate ? `${startDate} 00:00` : startDate
      this.form.endDate = endDate ? `${endDate} 00:00` : endDate
    },
    handleEdit() {
      let {
        startDate,
        endDate,
        addresses = [],
      } = this.data
      this.form = { ...form, ...this.data, dates: [startDate, endDate] }
      if (addresses.length > 0) {
        this.addressList = addresses.map(({ id, province, city, district, addr }) => {
          let districts = []
          if (province) {
            districts.push(province)
          }
          if (city) {
            districts.push(city)
          }
          if (district) {
            districts.push(district)
          }
          return {
            id,
            districts,
            addr,
          }
        })
      } else {
        this.onAddAddress()
      }
      this.editing = true
    },
    onAddAddress(index = 0) {
      let len = this.addressList.length
      this.addressList.splice(index, 0, {
        seq: len + 1,
        districts: [],
        addr: '',
      })
    },
    onRemoveAddress(index) {
      this.addressList.splice(index, 1)
    },
    confirmSubmit() {
      let { name, dates, ownManageRate } = this.form
      this.$message.destroy()
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (dates.length === 0) {
        this.$message.warning('请选择实施周期')
        this.$refs.datePicker2.focus()
        return
      }
      if (!this.$utils.isNum(ownManageRate)) {
        this.$refs.ownManageRate.focus()
        this.$message.warning('请输入美丽心灵管理费率')
        return
      }
      this.$confirm({
        title: '确认修改项目？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.$message.destroy()
      let { id, name, dates, content, ownManageRate } = this.form
      let addresses = this.addressList.filter(item => item.districts[0])
      let params = {
        id,
        name,
        startDate: dates[0] ? `${dates[0]} 00:00` : undefined,
        endDate: dates[1] ? `${dates[1]} 00:00` : undefined,
        content,
        ownManageRate,
        addresses: addresses.map(({ id, districts, addr }) => ({ id, province: districts[0], city: districts[1], district: districts[2], addr })),
      }
      this.saving = true
      updateMain(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.load()
            this.editing = false
            this.$root.$emit('reloadPrj')
          } else {
            this.$message.error(data.msg)
          }
          this.saving = false
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    openMemberForm(record) {
      if (record) {
        this.memberForm = { ...memberForm, ...record }
        this.memberModalTitle = '编辑管理人员'
      } else {
        this.memberModalTitle = '添加管理人员'
        this.memberForm = { ...memberForm, uid: this.$utils.uuid() }
      }
      this.memberModal = true
    },
    onRemoveMember(record) {
      let { memberId } = record
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delMember(memberId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.memberModal = false
                this.load()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {})
        },
      })
    },
    onSaveMember() {
      let { projectId } = this
      let { memberId, memberName, memberDuty, memberPost, experience, phone } = this.memberForm
      memberName = memberName.trim()
      this.$message.destroy()
      if (!memberDuty) {
        this.$message.warning('请选择人员类型')
        this.$refs.memberDuty.focus()
        return
      }
      if (memberName === '') {
        this.$message.warning('请输入人员姓名')
        this.$refs.memberName.focus()
        return
      }
      let params = {
        memberId,
        memberName,
        memberDuty,
        projectId,
        memberPost: memberPost.trim(),
        experience: experience.trim(),
        phone: phone.trim(),
      }
      saveMember(params).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.memberModal = false
          this.load()
        } else {
          this.$message.warn('操作失败')
        }
      })
    },
    onPoolSubmit() {
      this.poolModal = false
      this.load()
      this.$root.$emit('reloadPrj')
    },
  },
  created() {
    this.init()
  },
}
</script>
